import styled from 'styled-components';

export const LoadingContainer = styled.div`
  padding: 16px;
`;
